import { ref, onMounted, onBeforeUnmount } from "vue";
import MentionEventBus from "@plugins/richtext/plugins/mentions/service/event-bus.ts";
import { useEventBusWatch } from "@plugins/common/composables/event-bus-watch.ts";

export function useMention() {
  const mentionedTeachers = ref([]);
  const mentionedStudents = ref([]);
  const mentionedAppFeatures = ref([]);
  const { trackWatch } = useEventBusWatch();

  function resetMention() {
    mentionedStudents.value = [];
    mentionedTeachers.value = [];
    mentionedAppFeatures.value = [];
  }

  function handleMention(data) {
    mentionedTeachers.value = data.mentionedTeachers.map((user) => user.userUuid);
    mentionedStudents.value = data.mentionedStudents.map((user) => user.userUuid);
    mentionedAppFeatures.value = data.mentionedAppFeatures.map((user) => user.userUuid);
  }

  onMounted(() => {
    trackWatch(MentionEventBus.$on("handleMention", handleMention));
  });

  onBeforeUnmount(() => {
    resetMention();
  });

  return {
    mentionedTeachers,
    mentionedStudents,
    mentionedAppFeatures,
    resetMention,
    handleMention,
  };
}
